import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import styles from '../styles.scss'
import { Box, Flex } from 'reflexbox'
import { TableCell } from 'react-toolbox/lib/table'
import { ViewTable } from 'components/custom/ModifyTable/index'

import { defaultSearchFilterNames } from '../constants'

const tableHeadContent = {
  project_id: (<TableCell key={0}>Project ID</TableCell>),
  project_name: (<TableCell key={1}>Project Name</TableCell>),
  modified: (<TableCell key={2}>Modified Keys</TableCell>)
}

class SuccessPage extends Component {
  successRender = () => {
    let list = this.props.list
    let display = []
    if (list.length > 0) {
      display = list.map((project, idx) => {
        return {
          project_id: project.id,
          project_name: project.name,
          modified: project.modified.map((key) => {
            return defaultSearchFilterNames[key]
          }).join(", ")
        }
      })
    }
    return (
      <div>
        <p>Submitted Projects</p>
        <ViewTable
          tableHeadContent={tableHeadContent}
          source={display}
        />

        <br />
        <Flex
          align='center'
          column
          auto
          styleName='flexContainer'
        >
          <p>
            Error with the following projects
          </p>
          <p>
            {this.props.errors}
          </p>
          <Box auto />
        </Flex>
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.successRender()}
      </React.Fragment>
    )
  }
}

export default CSSModules(SuccessPage, styles)
